import { NAME } from './name.actions';
import { SESSION } from '../session';

const INITIAL_STATE = {};

export function NameReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case NAME.SET_SELECTED_ID:
      return { selectedId: payload };
    case SESSION.CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
}
